// extracted by mini-css-extract-plugin
export var sectionHeaderWrapper = "SectionHeader-module--section-header-wrapper--1ng2X";
export var sectionHeaderWrapperDark = "SectionHeader-module--section-header-wrapper--dark--2_4gv";
export var sectionHeader = "SectionHeader-module--section-header--g4cTo";
export var sectionSubheader = "SectionHeader-module--section-subheader--2Gtrl";
export var sectionHeaderLine = "SectionHeader-module--section-header--line--zK8dC";